import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentTemplateDTO, DocumentTemplateSTO } from "../../models/document-templates";
import { BaseApiService } from "../base/base-api.service";

export class DocumentTemplatesApiService extends BaseApiService<DocumentTemplateDTO, DocumentTemplateSTO> {
  constructor() {
    super({
      servicePath: "/DocumentTemplate",
      loadItemsPath: "/GetDocumentTemplates",
      saveItemsPath: "/SaveDocumentTemplates",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
